import { convertCentsToDollars } from '@clearverify/utils';

import { InitialBillingRulesInfoFragment, RevenueShareType } from 'src/api';

import { EmployerInitialBillingFormFields, VerifierBillingRulesFormFields } from '../types';

export const getVerifierInitialBillingRulesInitialValues = (
  initialBillingRules: InitialBillingRulesInfoFragment | undefined,
) => {
  return {
    [VerifierBillingRulesFormFields.voI]: initialBillingRules?.voI
      ? convertCentsToDollars(initialBillingRules.voI)
      : null,
    [VerifierBillingRulesFormFields.voE]: initialBillingRules?.voE
      ? convertCentsToDollars(initialBillingRules.voE)
      : null,
    [VerifierBillingRulesFormFields.reverification]: initialBillingRules?.reverification
      ? convertCentsToDollars(initialBillingRules.reverification)
      : null,
  };
};

export const getEmployerInitialBillingRulesInitialValues = (
  initialBillingRules: InitialBillingRulesInfoFragment | undefined,
) => {
  return {
    [EmployerInitialBillingFormFields.revenueShare]:
      initialBillingRules?.revenueShareType === RevenueShareType.Flat
        ? convertCentsToDollars(initialBillingRules.revenueShareFlat)
        : initialBillingRules?.revenueSharePercents,
    [EmployerInitialBillingFormFields.revenueShareType]: initialBillingRules?.revenueShareType,
  };
};
